<template>
  <el-dialog
    title="草稿箱"
    center
    v-model="visible"
    width="70%"
    @close="handleClose"
  >
    <div class="draft-list">
      <div v-if="list.length === 0" class="empty-tip">暂无草稿数据</div>
      <div class="draft-item" v-for="item in list" :key="item.id">
        <!-- 封面图 -->
        <div class="draft-img">
          <img
            v-if="item.coverUrl"
            :src="`https://${item.coverUrl}`"
            alt="样衣封面"
          />
          <div v-else class="no-img">无封面图</div>
        </div>
        <div class="draft-info">
          <div class="draft-time">
            {{ $day(item.date).format("YYYY‑MM‑DD") || "" }}
          </div>
          <div style="margin-top: 12px">
            <span style="margin-right: 30px"
              >样衣编号：{{ item.outerKey || "" }}</span
            >
            面料编号：{{ item.name || "" }}
          </div>
          <div class="draft-title" style="margin-top: 12px">
            标题：{{ item.title || "" }}
          </div>
        </div>
        <div class="draft-operate">
          <el-button type="text" class="btn" @click="handleEdit(item)"
            >编辑</el-button
          >
          <el-popconfirm
            title="确定删除这条草稿？"
            @confirm="handleDelete(item)"
          >
            <template #reference>
              <el-button type="text" class="btn">删除</el-button>
            </template>
          </el-popconfirm>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "Drafts",
  props: {
    draftList: {
      type: Array,
      default: () => [],
    },
    num: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visible: false,
      list: [],
      nums: 0,
    };
  },
  watch: {
    draftList: {
      immediate: true,
      handler(val) {
        this.list = [...val];
      },
    },
    num: {
      immediate: true,
      handler(val) {
        this.nums = val;
      },
    },
  },
  methods: {
    open() {
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
    },
    // 编辑：回填草稿数据给父组件，附带图片信息
    handleEdit(row) {
      // categoryList数组转id数组给formData.categoryId
      const categoryIds = row.categoryList
        ? row.categoryList.map((c) => c.id)
        : [];
      const fillData = {
        proid: row.id,
        productCode: row.outerKey || "",
        productpm: row.name || "",
        width: row.width || "",
        weight: row.weight || "",
        composition: row.ingredients || "",
        quantify: row.quantify || "",
        remark: row.remark || "",
        yarnCount: row.yarnCount || "",
        density: row.density || "",
        specification: row.specification || "",
        title: row.title || "",
        content: row.content || "",
        categoryId: categoryIds,
        flag: 0,
      };
      // ===== 新增图片原始数据，传给父组件 =====
      const imageData = {
        coverUrl: row.coverUrl || "",
        particularsList: row.particularsList || [],
        colorcardList: row.colorcardList || [],
      };
      // 派发事件，父组件接收回填表单 + 图片数据
      this.$emit("fillDraft", fillData, imageData);
      this.handleClose();
    },
    // 删除草稿 根据nums区分接口
    async handleDelete(row) {
      let res;
      try {
        if (this.nums === 1) {
          res = await this.$api.Product.del({
            id: row.id,
          });
        } else {
          res = await this.$api.Operation.UserProductlaunch.dels({
            id: row.id,
          });
        }
        if (res.data.code === "200") {
          this.$message.success("删除成功");
          //通知父重新拉取草稿列表
          this.$emit("refreshDraft");
        } else {
          this.$message.error(res.data.msg || "删除失败");
        }
      } catch (e) {
        this.$message.error("请求异常");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.draft-list {
  max-height: 60vh;
  overflow-y: auto;
}
.empty-tip {
  text-align: center;
  color: #999;
  padding: 40px 0;
}
.draft-item {
  display: flex;
  align-items: center;
  border: 1px dashed #999;
  padding: 16px;
  margin-bottom: 12px;
  gap: 16px;
}
.draft-info {
  flex: 1;
  color: black;
  font-size: 18px;
  .draft-time {
    margin-bottom: 8px;
  }
  .draft-title {
    margin-top: 6px;
  }
}
.draft-img {
  width: 100px;
  height: 134px;
  flex-shrink: 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .no-img {
    width: 100%;
    height: 100%;
    background: #eee;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
  }
}
</style>
<style>
.btn {
  color: black;
}
</style>
